import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CourseCard from "../cards/CourseCard";
import { Container, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import color from "./Colors";

interface Course {
  courseName: string;
  teachers: string[];
  localRating: number;
  globalRating: number;
  price: number;
  level: string;
  duration: string;
  image: string;
  courseId: number;
}

interface CoursesCarouselProps {
  title?: string;
  courses: Course[];
}

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 768, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

interface CustomArrowProps {
  onClick?: () => void;
}

const CustomLeftArrow: React.FC<CustomArrowProps> = ({ onClick }) => (
  <IconButton
    onClick={onClick}
    sx={{
      position: "absolute",
      left: 1,
      // zIndex:1000000000,
      top: "50%",
      transform: "translateY(-50%)",
      bgcolor: color.firstColor,
      color: "white",
      boxShadow: 3,
      "&:hover": {
        color: color.firstColor,
      },
    }}
  >
    <ArrowBackIosIcon sx={{ translate: "5px 0px" }} />
  </IconButton>
);

const CustomRightArrow: React.FC<CustomArrowProps> = ({ onClick }) => (
  <IconButton
    onClick={onClick}
    sx={{
      position: "absolute",
      right: 1,
      top: "50%",
      transform: "translateY(-50%)",
      bgcolor: color.firstColor,
      color: "white",
      boxShadow: 3,
      "&:hover": {
        color: color.firstColor,
      },
    }}
  >
    <ArrowForwardIosIcon />
  </IconButton>
);

const CoursesCarousel: React.FC<CoursesCarouselProps> = ({
  title,
  courses,
}) => {
  return (
    <Container
      sx={(theme) => ({
        mt: 5,
        height: "auto",
        border: "solid 1.5px",
        borderColor: color.firstColor,
        borderRadius: "190px 0px 190px 0px",
        pt: 10,
        flexWrap: "wrap",
        overflow: "hidden",
        bgcolor:
          theme.palette.mode === "light"
            ? "color.secondColor"
            : "rgba(0, 0, 0, 0.4)",
        // backdropFilter: "blur(2px)",
        boxShadow: "0px 0px 90px rgba(0, 0, 0, 0.14)",
      })}
    >
      {title && (
        <Typography
          variant="h4"
          component="h2"
          //   gutterBottom
          textAlign="center"
          fontWeight="bold"
          sx={{
            background: color.textColor,
            textAlign: "center",
            color: "white",
            width: "fit-content",
            margin: "auto",
            fontSize: "28px",
            padding: "4px 16px",
            borderRadius: "4px",
            mb: 2,
          }}
        >
          {title}
        </Typography>
      )}
      <Box sx={{ m: 0, p: 3, pl: 0, pr: 0, position: "relative" }}>
        <Carousel
          responsive={responsive}
          infinite
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
          draggable={false}
        >
          {courses.map((item: any) => (
            <CourseCard
              key={item.id}
              courseName={item.title}
              teachers={item.teachersName}
              localRating={item.localRating || 0}
              globalRating={item.globalRating || 0}
              price={item.price || 0}
              level={item.level || "Beginner"}
              duration={`${item.timeline || 0}`}
              image={item.coverImage}
              courseId={item.id}
              unitOfPrice={item.unitOfPrice}
            />
          ))}
        </Carousel>
      </Box>
    </Container>
  );
};

export default CoursesCarousel;
